var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 141,
    viewBox: "0 0 169 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_3801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.1735 79.6089L73.1816 99.2542L97.1328 99.2028L85.1735 79.6089Z",
    fill: "#0089CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1568 40.2256L25.125 99.2158H49.1117L73.1487 59.8709L61.1568 40.2256Z",
    fill: "#0089CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.125 59.7767L121.319 99.25H145.19L109.058 40.2256L97.125 59.7767Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1328 20.4367L85.1735 0.842773L73.1816 20.4909L85.141 40.0849L97.1328 20.4367Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6463 115.033C61.2957 115.033 64.5525 117.924 64.5525 122.79C64.5525 126.597 61.6507 129.353 57.4355 129.913L65.3275 140.42H59.4056L51.8152 130.478H41.1959V140.42H36.5488V115.033H53.6492H53.6463ZM41.1929 119.511V126.072H54.3089C57.0214 126.072 59.9025 125.858 59.9025 122.79C59.9025 119.722 56.2079 119.508 54.2172 119.508H41.1929V119.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.086 140.836L111.007 124.276L109.895 123.394V140.414H105.248V114.604H105.295L126.374 131.165L127.487 132.047V115.027H132.134V140.836H132.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7416 140.418H32.2377L16.1667 114.069H16.0691L-0.00195312 140.418H5.49703L8.25096 135.832H23.9493L26.7446 140.418H26.7416ZM16.1193 122.565C18.3734 126.069 19.3436 127.724 21.6094 131.451H10.5789C12.9513 127.573 13.8476 126.069 16.1193 122.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.872 140.423H168.369L152.298 114.074H152.2L136.129 140.423H141.628L144.382 135.837H160.08L162.875 140.423H162.872ZM152.25 122.569C154.504 126.074 155.474 127.729 157.74 131.456H146.71C149.082 127.578 149.978 126.074 152.25 122.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6207 135.943V129.79H95.6647V125.409H77.6207V119.508H97.7265V115.033H72.9707V140.417H98.4542V135.943H77.6207Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_3801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168.354,
    height: 140,
    fill: "white",
    transform: "translate(0 0.872559)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.337f744f33625ed6f307fdec21acd5db.svg";
export { ForwardRef as ReactComponent };